import { useMemo, useState } from "react"

import { UsePopoverMenuProps, UsePopoverMenuRes } from "./types"
import usePopoverMenu from "./usePopoverMenu"

export type UseLocalSearchPopoverMenuProps<T> = Omit<
  UsePopoverMenuProps<T>,
  "onChangeQuery"
>

export type UseLocalSearchPopoverMenuRes = UsePopoverMenuRes

function useLocalSearchPopoverMenu<T>(
  props: UseLocalSearchPopoverMenuProps<T>
): UseLocalSearchPopoverMenuRes {
  const { items, labelExtractor } = props

  const [query, setQuery] = useState("")

  const filteredItems = useMemo(() => {
    return items.filter((item) =>
      labelExtractor(item).toLowerCase().includes(query.toLowerCase())
    )
  }, [items, labelExtractor, query])

  return usePopoverMenu({
    ...props,
    items: filteredItems,
    onChangeQuery: setQuery,
  })
}

export default useLocalSearchPopoverMenu
